module.exports = __webpack_public_path__ + "static/img/atm-step-1.74e4cf28.png";